var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not_found"},[_c('h1',{staticClass:"code"},[_vm._v("404")]),_c('h1',{staticClass:"message text-main"},[_vm._v(_vm._s(_vm.$t('home.pageNotFound')))]),_c('div',[_c('a',{staticClass:"btn g-primary-button mt-3",attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.$t('home.backToHome')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }